import { useState, useEffect, useRef } from 'react';
import { useAuth } from './useAuth.js';
import { TableSessionService } from '../services/tableSessionService.js';

/**
 * Hook to poll for pending table requests (notification dot)
 * Polls every 10 seconds when authenticated
 */
export const usePendingTableRequests = () => {
  const { outletId, isAuthenticated } = useAuth();
  const [pendingCount, setPendingCount] = useState(0);
  const [pendingSessions, setPendingSessions] = useState([]);
  const pollRef = useRef(null);

  useEffect(() => {
    if (!isAuthenticated || !outletId) {
      setPendingCount(0);
      setPendingSessions([]);
      return;
    }

    const poll = async () => {
      try {
        const data = await TableSessionService.getPendingSessions(outletId);
        setPendingCount(data.pending_count || 0);
        setPendingSessions(data.sessions || []);
      } catch (err) {
        // Silently fail — don't disrupt UX for polling errors
      }
    };

    poll(); // immediate first call
    pollRef.current = setInterval(poll, 10000);

    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, [isAuthenticated, outletId]);

  return { pendingCount, pendingSessions };
};
